export default __webpack_public_path__ + "static/media/ai_limiter.277a3124.png";